<template>
    <div class="rs">
        <span class="rs-stars" :aria-label="`${score}/${max}`">
            <i
                v-for="star in max"
                :key="star"
                :class="star <= score ? 'fas fa-star' : 'fal fa-star'"
                class="rs-star"
            ></i>
        </span>
        <span class="rs-score">{{ score }}/{{ max }}</span>
    </div>
</template>

<script>
import { readRatingMax, clampRatingScore } from '@/config/rating'

export default {
    name: 'RatingStars',
    props: {
        // Score given by the citizen
        value: { default: null },
        // Attribute config, object or JSON string depending on the endpoint
        config: { default: null }
    },
    computed: {
        max() {
            return readRatingMax(this.config)
        },
        score() {
            return clampRatingScore(this.value, this.max)
        }
    }
}
</script>

<style scoped>
.rs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.rs-stars {
    display: inline-flex;
    gap: 3px;
    color: #f59e0b;
    font-size: 0.95rem;
}

.rs-star {
    line-height: 1;
}

.rs-score {
    font-size: 0.8rem;
    font-weight: 600;
    color: #64748b;
}

@media (max-width: 640px) {
    .rs-stars {
        font-size: 0.85rem;
        gap: 2px;
    }
}
</style>
